import { useQuery } from '@tanstack/react-query';
import { workLogKeys } from '@/entities/work-log';
import { fetchWorkLogLifetimeStats } from '../api';

export function useWorkLogLifetimeStats(userId: string | undefined) {
  return useQuery({
    queryKey: workLogKeys.lifetimeStats(userId),
    queryFn: () => fetchWorkLogLifetimeStats(),
    enabled: !!userId,
    staleTime: 30_000,
  });
}
